/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { ProductStore } from '../stores';

export const ProductContext = createContext<ProductStore>({} as ProductStore);
